import { polygonArea } from './geometry';
import type { State } from './types';

export interface LegalCheckResult {
  siteArea: number;
  totalFootprint: number;
  totalGfa: number;
  bcr: number;
  far: number;
  bcrOk: boolean;
  farOk: boolean;
}

export function computeLegalCheck(s: State): LegalCheckResult {
  const siteArea = s.site.points.length >= 3 ? Math.abs(polygonArea(s.site.points)) : 0;
  const totalFootprint = s.buildings.reduce((sum, b) => sum + b.width * b.depth, 0);
  const totalGfa = s.buildings.reduce((sum, b) => sum + b.width * b.depth * b.floors, 0);
  const bcr = siteArea > 0 ? (totalFootprint / siteArea) * 100 : 0;
  const far = siteArea > 0 ? (totalGfa / siteArea) * 100 : 0;
  return {
    siteArea,
    totalFootprint,
    totalGfa,
    bcr,
    far,
    bcrOk: bcr <= s.zoning.bcrLimit,
    farOk: far <= s.zoning.farLimit,
  };
}
